module.exports = __webpack_public_path__ + "static/media/ventodaest.bbf70893.jpeg";